/* ============================================================
   Barcode Code128-B แบบ SVG — ไม่พึ่ง library ภายนอก
   รองรับตัวอักษร ASCII 32-126 (ตัวเลข อังกฤษ และเครื่องหมาย)
============================================================ */

/* ตารางลายเส้นมาตรฐาน Code128 (ค่า 0-106)
   แต่ละตัวคือความกว้างสลับ แท่งทึบ/ช่องว่าง */
const PATTERNS = [
  "212222","222122","222221","121223","121322","131222","122213","122312","132212","221213",
  "221312","231212","112232","122132","122231","113222","123122","123221","223211","221132",
  "221231","213212","223112","312131","311222","321122","321221","312212","322112","322211",
  "212123","212321","232121","111323","131123","131321","112313","132113","132311","211313",
  "231113","231311","112133","112331","132131","113123","113321","133121","313121","211331",
  "231131","213113","213311","213131","311123","311321","331121","312113","312311","332111",
  "314111","221411","431111","111224","111422","121124","121421","141122","141221","112214",
  "112412","122114","122411","142112","142211","241211","221114","413111","241112","134111",
  "111242","121142","121241","114212","124112","124211","411212","421112","421211","212141",
  "214121","412121","111143","111341","131141","114113","114311","411113","411311","113141",
  "114131","311141","411131","211412","211214","211232","2331112",
];

const START_B = 104;
const STOP = 106;

/* แปลงข้อความเป็นลำดับแท่ง/ช่องว่าง */
function encode(text) {
  const clean = String(text ?? "").replace(/[^\x20-\x7E]/g, "");
  if (!clean) return null;

  const values = [START_B];
  for (const ch of clean) values.push(ch.charCodeAt(0) - 32);

  // checksum = (start + ผลรวมของ ตำแหน่ง x ค่า) % 103
  let sum = START_B;
  for (let i = 1; i < values.length; i++) sum += values[i] * i;
  values.push(sum % 103);
  values.push(STOP);

  // แปลงเป็นชุดความกว้าง แล้วรวมเป็นแท่ง (index คู่ = แท่งทึบ)
  const bars = [];
  for (const v of values) {
    const p = PATTERNS[v];
    if (!p) continue;
    for (let i = 0; i < p.length; i++) {
      bars.push({ width: Number(p[i]), fill: i % 2 === 0 });
    }
  }
  return { bars, text: clean };
}

export default function Barcode128({
  value,
  height = 40,
  moduleWidth = 1.4,
  showText = true,
  fontSize = 9,
  className = "",
}) {
  const result = encode(value);
  if (!result) return null;

  const { bars, text } = result;
  const totalModules = bars.reduce((s, b) => s + b.width, 0);
  const width = totalModules * moduleWidth;
  const textH = showText ? fontSize + 3 : 0;

  let x = 0;
  const rects = bars.map((b, i) => {
    const w = b.width * moduleWidth;
    const rect = b.fill ? (
      <rect key={i} x={x} y={0} width={w} height={height} fill="#000" />
    ) : null;
    x += w;
    return rect;
  });

  return (
    <svg
      className={className}
      viewBox={`0 0 ${width} ${height + textH}`}
      width="100%"
      height={height + textH}
      preserveAspectRatio="xMidYMid meet"
      shapeRendering="crispEdges"
    >
      {rects}
      {showText && (
        <text
          x={width / 2}
          y={height + fontSize}
          textAnchor="middle"
          fontSize={fontSize}
          fontFamily="monospace"
          fill="#000"
        >
          {text}
        </text>
      )}
    </svg>
  );
}
